import { Delete, PhoneCall, PhoneOff } from 'lucide-react';
import React, { useContext, } from 'react';

import { Discador, DiscadorContext, useKeyboardInput } from '../../../../../DiscadorExpert';
import { aplicarMascara } from '../../../../../../utils/mascaraTelefone';

export const LigacaoExpert = () => {
  const {
    iniciarSessao,
    finalizarSessao,
    onCall,
    isLogged,
    onRinging,
    finalizarChamada,
    iniciarChamada,
    dadosLogin,
    isConnected,
  } = useContext(DiscadorContext);

  const { virtualInteraction, value: phoneNumber } = useKeyboardInput('');

  return (
    <div className="h-full w-full overflow-y-auto">
      <div className={`flex w-full max-w-xl flex-col items-center text-xs lg:text-sm ${!isConnected && 'hidden'}`}>
        <Discador.Root>
          <Discador.Header
            onRinging={onRinging}
            onCall={onCall}
            phoneNumber={aplicarMascara(phoneNumber)}
            isLogged={isLogged}
            onChangeHandler={() => {
              if (isLogged) return finalizarSessao();
              iniciarSessao();
            }}
            isHibrido
          />
          <Discador.NumbersRoot>
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="1"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="2"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="3"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="4"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="5"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="6"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="7"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="8"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="9"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number onNumberPressed={() => { }} number="*" hidden />
            <Discador.Number
              onNumberPressed={virtualInteraction}
              number="0"
              disabled={!isLogged || onCall || onRinging}
            />
            <Discador.Number onNumberPressed={() => { }} number="#" hidden />
          </Discador.NumbersRoot>
          <Discador.ActionsRoot>
            <Discador.Action
              icon={PhoneCall}
              className="rounded-full bg-green-600 p-3 disabled:bg-green-300 disabled:hover:bg-green-300"
              disabled={onCall || onRinging || phoneNumber.length < 10 || !isLogged}
              iconColor="#fff"
              onClick={() => {
                iniciarChamada(
                  dadosLogin!.idUsuario,
                  phoneNumber.substring(0, 2),
                  phoneNumber.substring(2),
                  dadosLogin!.idGrupo
                );
              }}
            />

            <Discador.Action
              icon={PhoneOff}
              className="rounded-full bg-red-700 p-3 disabled:bg-red-200 disabled:hover:bg-red-200"
              iconColor="#fff"
              disabled={!onCall || !isLogged}
              onClick={() => {
                finalizarChamada(dadosLogin!.idUsuario);
              }}
            />

            <Discador.Action
              icon={Delete}
              className="rounded-full bg-slate-300 p-3"
              disabled={onCall || onRinging || !isLogged}
              onClick={() => virtualInteraction('Backspace')}
            />
          </Discador.ActionsRoot>
        </Discador.Root>
      </div>

      <div
        className={`mt-5 flex  w-full max-w-xl  items-center justify-center text-xs lg:text-sm ${isConnected && 'hidden'
          }`}
      >
        <h4>WebSocket sem conexão.</h4>
      </div>
    </div>
  )
}